import { currentCultureSettings } from "~/EasyProjectsCommon/setCulture";
import { dateUtility } from "../../EasyProjectsCommon/Dates/DateUtility";
import { timeUtility } from "../../EasyProjectsCommon/Dates/TimeUtility";
import { numericUtility } from "../../EasyProjectsCommon/NumericUtility";
import { commonResx } from "../../resxDist/commonResx";

const formatDecimal = (value: number) => {
    if (value != null) {
        return new Intl.NumberFormat(currentCultureSettings.locale, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    }

    return "";
};

export const valuesFormatter = {
    formatBool: (value: boolean | null) => (value ? commonResx.yes : commonResx.no),
    formatNumeric: (value: number | null) => numericUtility.formatLocal(value),
    formatDate: (value: Date | null) => dateUtility.formatAsMediumOrShort(value),
    formatAsDateFormat: (value: Date | null) => dateUtility.formatAsDateFormat(value),
    formatAsTime: (value: number) => timeUtility.formatFromMinutes(value),
    formatAsMinutes: (value: string) => timeUtility.formatToMinutes(value),
    formatAsAbbrFromHours: (value: number) => timeUtility.formatAsAbbrFromHours(value),
    formatAsAbbrFromMinutes: (value: number) => timeUtility.formatAsAbbrFromMinutes(value),
    formatDecimal,
};
